<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToLogin = () => {
  router.push({ name: 'login' })
}
</script>

<template>
  <v-btn
    @click="goToLogin"
    variant="text"
    aria-label="Log in redirect"
    class="header-toolbar__auth-btn v-btn__light"
    >Log in</v-btn
  >
</template>

<style scoped>
.header-toolbar__auth-btn {
  height: 60px !important;

  font-size: 18px;
  font-style: normal;
  line-height: 22px; /* 122.222% */

  background: transparent !important;
}
</style>
